import 'swiper/swiper-bundle.css';

import { Button, Icon, Image, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { HomeTopCategoriesSkeletons } from '@hero/components/skeletons';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';
import { cleanObjectEmptyFields } from '@hero/utils';

import * as S from './style';

export function HomePopularCollections() {
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const swiper = useRef();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = {
    spaceBetween: 12,
    slidesPerView: 'auto',
    slidesPerGroup: 6,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 4
    }
  };

  const { data: dataGiftTemplates, isLoading } = useGetCSEntries({
    entryCode: 'sgb_dashboard_gift_templates',
    params: {
      asc: 'order'
    }
  });

  const filteredTemplates = dataGiftTemplates?.entries.filter(t => t.enabled);

  return (
    <S.HomePopularCollectionsWrapper>
      <S.HeaderWrapper>
        <Typography variant="subtitle1Bold">{t('popularCollections')}</Typography>
        <VerticalDivider
          $margin="0 16px"
          $height="24px"
          color="var(--color-components-input-border-strong)"
        />
        <Button
          size="lg"
          variant="link"
          color="bg"
          onClick={() =>
            navigate({
              pathname: ROUTE_PATHS.GIFT_CATALOG,
              search: `?${createSearchParams(
                cleanObjectEmptyFields({
                  collectionIds: filteredTemplates[0]?.product_criteria?.collection_id,
                  categoryIds: filteredTemplates[0]?.product_criteria?.category_id
                })
              )}`
            })
          }
        >
          {t('seeAll')}
        </Button>
      </S.HeaderWrapper>
      <S.HomePopularCollections>
        <S.NavigationButton color="secondary" variant="link" ref={navigationPrevRef}>
          <Icon name="left-chevron" size="lg" />
        </S.NavigationButton>

        {isLoading ? (
          <S.CategorySkeleton>
            <HomeTopCategoriesSkeletons />
          </S.CategorySkeleton>
        ) : (
          <Swiper
            ref={swiper}
            {...params}
            pagination={{
              clickable: true
            }}
          >
            {filteredTemplates?.map(template => (
              <SwiperSlide
                style={{
                  width: 300,
                  height: 340,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                key={template.uid}
              >
                <S.OccasionItem
                  as="div"
                  key={template.uid}
                  onClick={() => {
                    navigate({
                      pathname: ROUTE_PATHS.GIFT_CATALOG,
                      search: `?${createSearchParams(
                        cleanObjectEmptyFields({
                          collectionIds: template?.product_criteria?.collection_id,
                          categoryIds: template?.product_criteria?.category_id
                        })
                      )}`
                    });
                  }}
                >
                  <Typography variant="body2SemiBold">{template.title}</Typography>
                  <Image src={template.cover_image.url} width="100%" />
                </S.OccasionItem>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <S.NavigationButton color="secondary" variant="link" ref={navigationNextRef}>
          <Icon name="right-chevron" size="lg" />
        </S.NavigationButton>
      </S.HomePopularCollections>
    </S.HomePopularCollectionsWrapper>
  );
}
